import { render, staticRenderFns } from "./DrivingTips.vue?vue&type=template&id=88679022&scoped=true&"
var script = {}
import style0 from "./DrivingTips.vue?vue&type=style&index=0&id=88679022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88679022",
  null
  
)

export default component.exports